import Button from "../button/button.component";
import Checkbox from "../checkbox/checkbox.component";
import FormControlLabel from "../formControlLabel/formControlLabel.component";
import Typography from "../typography/typography.component";

const SelecaoTitulosFiltro = ({
  todasSelecionadas,
  onChangeTodas,
  quantidadeSelecionada,
  onLimparSelecao,
}) => {
  return (
    <div className="d-flex flex-row align-items-center ms-3">
      <FormControlLabel
        control={
          <Checkbox
            checked={todasSelecionadas}
            onChange={(event) => onChangeTodas(event.target.checked)}
          />
        }
        label="Selecionar todos os títulos do filtro"
      />
      <Typography className="text-secondary ms-2">
        {quantidadeSelecionada === 1
          ? "1 título selecionado"
          : `${quantidadeSelecionada} títulos selecionados`}
      </Typography>
      {quantidadeSelecionada > 0 && (
        <Button size="small" sx={{ ml: 1 }} onClick={onLimparSelecao}>
          Limpar seleção
        </Button>
      )}
    </div>
  );
};

export default SelecaoTitulosFiltro;
